import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { NewProjectPageData } from "@/ui/NewProjectPage";
import { NewProjectPage } from "@/ui/NewProjectPage";
import { fetchJson } from "../api";

export const NewProjectRoute = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<NewProjectPageData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = t("meta.titleWithApp", { page: t("newProject.pageTitle"), appName: t("common.appName") });
  }, [t]);

  useEffect(() => {
    fetchJson<NewProjectPageData>("/api/ui/new-project")
      .then(setData)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : t("common.fetchFailed")));
  }, [t]);

  if (error) {
    return <div className="text-destructive p-6">{error}</div>;
  }
  if (!data) {
    return <div className="text-muted-foreground p-6">{t("common.loading")}</div>;
  }
  return <NewProjectPage data={data} />;
};
